// extracted by mini-css-extract-plugin
module.exports = {"root":"Loader_root__2h5lo","bg":"Loader_bg__3S5xZ","fg":"Loader_fg__7pQke","fg-spin":"Loader_fg-spin__2wlIf"};